<i18n>
{
	"en": {
		"general": "General",
		"tms": "TMS",
		"cancelLabel": "Cancel",
		"save": "Save settings",
		"title": "Settings",
		"systemSettings" : "System parameters"
	},
	"no": {
		"general": "Generelt",
		"tms": "TMS",
		"cancelLabel": "Avbryt",
		"save": "Lagre innstillingene",
		"title": "Innstillinger",
		"systemSettings" : "System parameterer"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		:confirmLabel="$t('save')"
		:cancelLabel="$t('cancelLabel')"
		@close="$emit('close')"
		@ok="onSave"
		@cancel="onCancel"
	>
		<div class="settings">
			<div class="settings-nav">
				<h4 class="settings-nav-header">{{$t('title')}}</h4>
				<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar>
					<template v-slot="slotProps">
						<t-tab :value="slotProps.item" :selected="slotProps.isSelected" :sidebar="slotProps.sidebar">
							{{$t(slotProps.item.key)}}
						</t-tab>
					</template>
				</t-tab-list>
			</div>
			<t-pane class="settings-content">
				<component :is="selectedTab.id" :ref="selectedTab.ref" />
			</t-pane>
		</div>
	</t-dialog>
</template>

<script>
import General from './General.vue';
import Tms from './Tms.vue';
import SystemSettings  from './SystemSettings.vue';
export default {
	name: 'Settings',
	components: { General, Tms, SystemSettings },
	props: { isShown: Boolean, },
	data() {
		return {
			tabs: [{ id:'General', key: 'general', ref: 'general' }, { id:'Tms', key: 'tms', ref: 'tms' }, { id:'SystemSettings', key: 'systemSettings', ref: 'systemSettings' }],
			selectedTab: { id:'General', key: 'general', ref: 'general' },
		};
	},
	methods: {
		onSave() {
			// Call specific sub section save handling as needed
			// returns true/false if page requires reload after
			let reload = this.$refs.general.processSave();

			if (reload)
				location.reload();
		},
		onCancel() {
			// Call specific sub section cancel handling as needed
			this.$refs.general.processCancel();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.settings {
	display: grid;
	grid-template-columns: 240px 760px;
	grid-column-gap: 20px;
	min-height: 500px;
}

.settings-nav {
	border-right: 2px solid get-color($border, 'default');
}

.settings-nav-header {
	margin-bottom: 20px;
}
</style>
